import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSpotifyStore } from '@/apps/Spotify/stores/useSpotifyStore';
import handleException from '@/common/utils/errors';

export const SpotifyCallback = () => {
  const navigate = useNavigate();
  const handleCallback = useSpotifyStore(state => state.handleCallback);

  useEffect(() => {
    const processCallback = async () => {
      try {
        await handleCallback();
        navigate('/'); // Redirect to main page after successful auth
      } catch (error) {
        handleException(error);
        navigate('/'); // Redirect to main page even on error
      }
    };

    processCallback();
  }, [handleCallback, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p>Processing Spotify login...</p>
    </div>
  );
}
